module.exports = __webpack_public_path__ + "img/beruf_digital.7d736736.jpg";